import ko from './ko.json'
import en from './en.json'

export default {
    'ko' : ko,
    'en' : en
}